'use client';

import { useState } from 'react';

import { FeatureCommentFormBase } from '@/fo/feature/comment/form/base';
import {
  PostComment,
  UiCommentSectionBase
} from '@/fo/ui/comment/section/base';

import { useComments } from '../../hooks/useComments';

export interface ClientComponentProps {
  slug: string;
  postId: number;
  initialCommentsCount: number;
  initialComments: PostComment[];
  initialRating: number;
}

export function ClientComponent({
  postId,
  slug,
  initialCommentsCount,
  initialComments,
  initialRating
}: ClientComponentProps) {
  const [open, setOpen] = useState(false);

  const { comments, fetchMoreComments, showLoadMore, commentsLoading } =
    useComments(slug, initialComments, initialCommentsCount);

  return (
    <>
      <FeatureCommentFormBase
        open={open}
        onOpenChange={setOpen}
        postId={postId}
      />
      <section>
        <UiCommentSectionBase
          comments={comments}
          commentsCount={initialCommentsCount}
          rating={initialRating}
          onOpenForm={() => setOpen(true)}
          onLoadMore={fetchMoreComments}
          showLoadMore={showLoadMore}
          commentsLoading={commentsLoading}
        />
      </section>
    </>
  );
}
